
import { ButtonBarItem, ButtonBarOptions } from "@/types/controls";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: {
    Icon
  }
})
export default class ButtonBar extends Vue {
  @Prop()
  value!: string | null;

  @Prop()
  placeholder?: string;

  @Prop({
    default() {
      return [];
    }
  })
  items!: ButtonBarItem[];

  @Prop()
  options?: ButtonBarOptions;

  get layout() {
    return this.options?.layout || "default";
  }

  get internalValue() {
    return this.value;
  }

  set internalValue(string: string | undefined | null) {
    if (!string) {
      this.$emit("input", null);
      return;
    }

    this.$emit("input", string);
  }

  get classes() {
    return {
      "breakdance-dense-button-toggle-multiline": this.layout === "multiline",
      "breakdance-dense-button-toggle": this.layout === "default"
    };
  }
}
